import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
var _excluded = ["setValue", "value"];
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import { useInstance } from 'intact-react';
import { useValue as useValueBase } from './basepicker';
import dayjs from 'dayjs';
import { last } from '../utils';
import { endTime } from './helpers';
import { PanelTypes, PanelFlags } from './usePanel';
export function useValue(formats, disabled, panel) {
  var instance = useInstance();
  var _useValueBase = useValueBase(formats, disabled, panel, function (v) {
      var _instance$get = instance.get(),
        type = _instance$get.type,
        range = _instance$get.range;
      return type !== 'datetime' && (!range || v.length === 2);
    }, function (v) {
      setValue(v, true);
    }, function () {
      var _instance$get2 = instance.get(),
        type = _instance$get2.type;
      return type === 'datetime' ? 'second' : type;
    }, function (dayjsValue, value) {
      if (instance.get('multiple') && panel.getPanel(PanelFlags.Start).value === PanelTypes.Time) {
        value.set(_concatInstanceProperty(dayjsValue).call(dayjsValue, [last(value.value)]));
      } else {
        value.set(_sliceInstanceProperty(dayjsValue).call(dayjsValue, 0));
      }
    }),
    setValue = _useValueBase.setValue,
    value = _useValueBase.value,
    rest = _objectWithoutPropertiesLoose(_useValueBase, _excluded);
  function onChangeDate(v, flag) {
    var _instance$get3 = instance.get(),
      multiple = _instance$get3.multiple,
      type = _instance$get3.type,
      range = _instance$get3.range;
    var _value;
    if (range) {
      var oldValue = last(value.value);
      if (!oldValue || oldValue.length === 2) {
        /**
         * if we select the first value or re-select the value
         * no matter what the flag is, we should set flag to start panel
         * #877
         */
        flag = PanelFlags.Start;
        _value = [fixDatetimeWithMinDate(v)];
      } else {
        _value = [oldValue[0], fixDatetimeWithMaxDate(v)];
        _sortInstanceProperty(_value).call(_value, function (a, b) {
          return a.isAfter(b) ? 1 : -1;
        });
      }
      instance.trigger('selecting', _value);
    } else {
      _value = fixDatetimeWithMinDate(v);
    }
    setValue(_value, false);
    if (type === 'datetime') {
      if (range) {
        // only change to time panel after selected start and end date
        if (_value.length === 2) {
          panel.changePanel(PanelTypes.Time, PanelFlags.Start);
          panel.changePanel(PanelTypes.Time, PanelFlags.End);
        }
      } else {
        panel.changePanel(PanelTypes.Time, flag);
      }
    } else if (!multiple && (!range || _value.length === 2)) {
      instance.hide();
    }
  }
  function fixDatetimeWithMinDate(v) {
    // the datetime must be greater than minDate, #406
    var minDate = disabled.minDate.value;
    if (minDate && v.isBefore(minDate)) {
      return minDate;
    }
    return v;
  }
  function fixDatetimeWithMaxDate(v) {
    // the tiem of end datetime should be set to 23:59:59, #878
    var maxDate = disabled.maxDate.value;
    var date = v.toDate();
    endTime(date);
    v = dayjs(date);
    if (maxDate && v.isAfter(maxDate)) {
      return maxDate;
    }
    return v;
  }
  return _extends({
    value: value,
    setValue: setValue,
    onChangeDate: onChangeDate
  }, rest);
}